var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-total-edit-content-wrapper",
    {
      attrs: { value: _vm.currentTab },
      on: {
        input: function ($event) {
          return _vm.$emit("update:currentTab", $event)
        },
      },
    },
    [
      _c(
        "w-row",
        [
          _c("w-col", { attrs: { xs: "12" } }, [
            _c("div", [
              _c(
                "div",
                { staticClass: "preview", style: _vm.value.Style.getStyle() },
                [_c("div", [_vm._v(" " + _vm._s(_vm.previewText) + " ")])]
              ),
            ]),
          ]),
        ],
        1
      ),
      _c(
        "w-row",
        [
          _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _c("w-input", {
                attrs: {
                  fancy: "",
                  value: _vm.value.Label.getTranslation(_vm.$i18n.locale),
                  label: _vm.$ct("total-label-text"),
                },
                on: {
                  input: function ($event) {
                    return _vm.value.Label.setTranslation(
                      $event,
                      _vm.$i18n.locale
                    )
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-row",
        [
          _c(
            "w-col",
            { attrs: { xs: "12", md: "6" } },
            [
              _c("app-color-picker", {
                attrs: {
                  fancy: "",
                  color: _vm.value.Style.Color,
                  label: _vm.$ct("text-color"),
                },
                on: {
                  input: function ($event) {
                    _vm.value.Style.Color = $event
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "w-col",
            { attrs: { xs: "12", md: "6" } },
            [
              _c("app-color-picker", {
                attrs: {
                  fancy: "",
                  color: _vm.value.Style.BackgroundColor,
                  label: _vm.$ct("background-color"),
                },
                on: {
                  input: function ($event) {
                    _vm.value.Style.BackgroundColor = $event
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "w-col",
            { attrs: { xs: "12", md: "4" } },
            [
              _c("w-checkbox", {
                staticClass: "bold",
                attrs: { label: _vm.$ct("bold") },
                model: {
                  value: _vm.value.Style.Bold,
                  callback: function ($$v) {
                    _vm.$set(_vm.value.Style, "Bold", $$v)
                  },
                  expression: "value.Style.Bold",
                },
              }),
            ],
            1
          ),
          _c(
            "w-col",
            { attrs: { xs: "12", md: "4" } },
            [
              _c("w-checkbox", {
                staticClass: "italic",
                attrs: { label: _vm.$ct("italic") },
                model: {
                  value: _vm.value.Style.Italic,
                  callback: function ($$v) {
                    _vm.$set(_vm.value.Style, "Italic", $$v)
                  },
                  expression: "value.Style.Italic",
                },
              }),
            ],
            1
          ),
          _c(
            "w-col",
            { attrs: { xs: "12", md: "4" } },
            [
              _c("w-checkbox", {
                staticClass: "underline",
                attrs: { label: _vm.$ct("underline") },
                model: {
                  value: _vm.value.Style.Underline,
                  callback: function ($$v) {
                    _vm.$set(_vm.value.Style, "Underline", $$v)
                  },
                  expression: "value.Style.Underline",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-row",
        [
          _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _c("w-checkbox", {
                attrs: { label: _vm.$ct("calculate-in-frontend") },
                model: {
                  value: _vm.value.CalculateInFrontend,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "CalculateInFrontend", $$v)
                  },
                  expression: "value.CalculateInFrontend",
                },
              }),
              _vm.value.CalculateInFrontend
                ? _c("div", { staticClass: "info-text" }, [
                    _vm._v(
                      " " + _vm._s(_vm.$ct("calculate-in-frontend-info")) + " "
                    ),
                  ])
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }